import { css } from '@emotion/core'

export const lightEmphasisBand = css`
  background: rgba(187, 236, 246, 1);
  padding: 1rem 0;
`

export const emphasisBand = css`
  background: rgba(0, 97, 132, 1);
  padding-bottom: 2em;
`
